module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 522.037 504.012",
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(-62.482 -42.339)"
    }
  }, [_c('path', {
    staticClass: "a",
    attrs: {
      "d": "M340.8,42.339q173.262,0,232.238,197.517l11.476,39.586q0,184.176-173.785,256.658-26.113,0-46.441,10.251L340.8,536.1l-22.977,10.251q-163.34,0-243.717-158.367l-11.49-49.373Q100.2,52.135,282.865,52.126Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "b",
    attrs: {
      "d": "M245.835,59.557a62.567,62.567,0,0,0-17.418,2.668c-3.25-.194-6.628-.323-10.294-.323-34.614,0-131.388,103.7-131.371,148.637,0,33.236,61.3,7.012,113.413-32.133a63.226,63.226,0,0,0,6.268,3.326c21.834,9.97,50.037,8.441,67.761-7.454,11.344-10.168,18.916-20.889,23.7-34.332,3.686-10.342,3.854-21.942,3.86-32.73C301.771,81.237,276.309,59.557,245.835,59.557Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "b",
    attrs: {
      "d": "M247.378,336.7c.019-1.91.1-3.812.1-5.725,0-74.449-185-82.243-185,0,0,57.823,29.01,107.84,71.313,132.507,6.868,16.575,23.7,29.777,50.531,29.777,44.712,0,61.674-36.63,50.95-64.482,1.944-6.638,3.681-13.7,5.169-21.138C264.982,391.111,267.308,356.612,247.378,336.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "b",
    attrs: {
      "d": "M564.247,302.369c-.3-13.952-7.871-27.44-20.913-36.812,9.594-27.657-7.523-63.017-51.46-63.017-25.393,0-41.777,11.838-49.282,27.148-15.291,5.14-25.228,15.744-29.8,28.03-2.577,1.115-5.25,2.069-7.735,3.34a71.731,71.731,0,0,0-13.833-1.329c-70.509,0-72.037,91.055-4.677,95.124a103.414,103.414,0,0,0,18.014,13.355c.431.265.938.451,1.377.7-34.782,36.134-63.328,77.192-63.319,102.531C342.616,550.863,667.26,344.058,564.247,302.369Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "b",
    attrs: {
      "d": "M352.174,201.643a7.971,7.971,0,0,0,4.085,1.735,16.157,16.157,0,0,0,1.588,1.688c5.8,5.278,67.4-16.054,87.071-31.731,14.528-11.576-7.209-11.809-33.074-6.136.185-.735-4.277-12.694-14.206-9.864a78.746,78.746,0,0,0-19,8.35A136.493,136.493,0,0,0,363.671,176.5C352.294,185.549,347.072,197,352.174,201.643Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "b",
    attrs: {
      "d": "M394.665,61.665c-1.21,1.823-1.251,4.042-.771,6.417a23.978,23.978,0,0,0-2.32,2.93c-6.667,10.344,76.017,86.975,120.007,107.669,32.5,15.282,18.693-15.074-9.5-48.659,1.579-.053,22.39-11.392,10.274-24-7.749-8.081-16.773-15.252-29.005-22.9-9.394-5.845-20.715-11.244-31.271-16.211C426.668,54.942,400.538,52.579,394.665,61.665Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "c",
    attrs: {
      "d": "M325.2,292.751q.2,1.821,6.741,3.05l1.823,4.926q.235,13.4,1.158,21.659L353.6,294.693l17.708-1.986.422,3.76-21.216,39.561q7.743,11.928,38.439,45.611a10.218,10.218,0,0,1,1.821,4.925,9.343,9.343,0,0,0-.832,3.9L379.808,391.6l-3.527,2.993-1.253.141L341.681,360.02l.287,2.56Q345.938,398,339.62,398.7l-5.069.567q-4.386-2.1-6.607-1.855a9.006,9.006,0,0,1-3.61,1.732l-1.594-2.414-1.132-10.079a1.163,1.163,0,0,1,1.161-1.454l-1.588-2.36c-.19-1.706.145-2.608,1.021-2.707l-2.726-12.489-5.1-45.49q-.746-6.663-3.668-21.378a1.115,1.115,0,0,0,1.114-1.4,1.138,1.138,0,0,1-1.4-1.164Q320.76,293.252,325.2,292.751Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "c",
    attrs: {
      "d": "M390.41,289.16h7.046q3.557,1.167,3.554,7.1,0,8.482-8.273,10.548-8.214-2.334-8.213-9.38v-1.168Q388.66,289.158,390.41,289.16Zm14.1,21.2q1.224,21.57,3.551,40.019h-1.165l1.165,2.389v5.88q0,8.7-3.551,9.437H391.574c-1.554,0-2.336-1.185-2.336-3.549q0-17.076-2.384-25.923a1.032,1.032,0,0,1,1.166-1.166l-1.166-5.886V312.746a71.037,71.037,0,0,0,7.05-1.216v1.216Q395.972,311.529,404.508,310.364Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "c",
    attrs: {
      "d": "M456.68,280.17l5.869,1.509a8.8,8.8,0,0,0,4.72-.989,8.308,8.308,0,0,0,3.488,1.391l-.288,5.876q-1.105,22.5.913,101.414-.345,7.047-10.937,6.525l-4.712-.23-4.365-7.277-2.387,1.053-2.273-1.281c-.6-.029-2.981.244-7.155.819q-21.384-1.053-22.522-21.115l.175-3.546q.708-14.453,23.494-22.414,14.167.111,14.313-2.851-1.671-38.457-3.342-52.019l.059-1.215Zm-20.625,83.9q2.073,5.465,4.421,6.113l1.22.06,11.814-.589.519-10.588-2.383-.117Q438.144,358.289,436.055,364.073Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "c",
    attrs: {
      "d": "M517.676,297.258l2.226.692q8.612,2.685,12.164,12.456l-.693,2.228q-.551,1.766-5.91,3.1l-3.393-1.06-2.638-3.268q-6.075-1.89-9.3,2.044l-1.042,3.343q2.2,9.344,9.938,11.758,10.328,14.773,8.627,23.622-8.419,27.024-27.5,21.076-.348,1.116-7.076-.984L487.4,370.5a1.023,1.023,0,0,1-.759-1.457l-2.577.419-1.114-.347q-4.508-1.4.4-17.139a1.033,1.033,0,0,0,1.459-.771l7.495,3.562,1.166.362q11.235,3.5,14.391-6.621.571-10.922-11.6-22.107-4.6-8.758-3.684-15.971Q506.24,293.7,517.676,297.258Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "c",
    attrs: {
      "d": "M488.2,378.469h3.248c1.094.342,1.636,1.391,1.636,3.141q0,3.755-3.809,4.669-3.786-1.032-3.785-4.152v-.517Q487.4,378.471,488.2,378.469Zm6.5,9.381q.559,9.547,1.639,17.709H495.8l.539,1.055v2.6q0,3.845-1.639,4.177h-5.96q-1.075,0-1.074-1.574a45.073,45.073,0,0,0-1.1-11.469c0-.346.181-.515.536-.515l-.536-2.606v-8.324q.418,0,3.249-.541v.541A17.6,17.6,0,0,1,494.7,387.85Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "c",
    attrs: {
      "d": "M504.594,386.279l2.173.54,3.249-.54q.535,0,.535,5.747,4.811-4.692,7.6-4.692h.56q6.277,0,8.672,6.778,1.072,14.592,1.638,14.59,0,3.12-3.274,3.119l-1.074-.514a4.516,4.516,0,0,1-2.174.514q-1.641-.515-1.638-3.119a3.928,3.928,0,0,1,.562-2.088q-1.462-11.469-3.811-11.468-5.421,2.229-5.421,5.724v1.569a16.024,16.024,0,0,0,.538,4.175,15.1,15.1,0,0,1-1.611,5.724l-2.737-.517-1.611,1.032h-.54q-2.17-.842-2.172-3.635v-1.571a77.058,77.058,0,0,0-1.1-15.106h.562a3.582,3.582,0,0,1-.562-1.571Q503.3,386.279,504.594,386.279Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "c",
    attrs: {
      "d": "M550.02,381.61a7.24,7.24,0,0,0,2.711,1.549v5.207q0,2.6-1.074,2.6a32.207,32.207,0,0,1-4.887-1.031,9.831,9.831,0,0,0-4.883,4.173v1.549q0,4.176,3.248,4.176l5.423-.517v.517l1.1-.517h.538q1.072.162,1.073,1.032v4.691l-.537,2.6h-3.784q-14.022,0-16.827-8.842v-1.057h.534a3.7,3.7,0,0,1-.534-1.546Q532.12,385.76,550.02,381.61Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "c",
    attrs: {
      "d": "M164.6,311.84q4.993,8.592,5.69,12.388l.2,1.068q-2.727.5-15.018,4.954l-.2-1.072-2.034,1.479-6.589,1.2q.246,1.359-3.527,11.8l2.178-.4a50.966,50.966,0,0,0,12.838-4.552,29.918,29.918,0,0,1,5.835,13.464q-3.963,5.2-17.885,7.74l.586,3.209q5.532,30.32,13.486,48.928l-2.231.407,2.077,5.2q.46,2.532-18.082,6.672l-2.075-5.207-.4-2.188q-.044-2.2,1.791-2.539a147.173,147.173,0,0,1-6.329-22.328q-1.654-15.23-2.455-19.61a.989.989,0,0,0-1.293-.92l.1-5.605-3.554-19.462q-2.7-14.795,16.175-29.751l9.907-1.809Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "c",
    attrs: {
      "d": "M233.1,314.678h3.324a9.1,9.1,0,0,1,4.482,1.086,9.094,9.094,0,0,1,4.482-1.086,55.776,55.776,0,0,1,1.108,9.89q9.267-5.49,15.662-5.49h5.59q1.611,0,3.376,3.266v2.224l-1.112,6.579a7.967,7.967,0,0,1,1.112,3.313l-2.217,1.088H254.359q-1.615,0-3.376,3.266,0,23.991,2.266,35.169L246.5,377.3q-12.288,0-12.287-3.313V370.72q-2.222-47.687-2.216-51.642Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "c",
    attrs: {
      "d": "M201.169,318.873q16.179,0,21.684,21.255l1.073,4.259q0,19.815-16.227,27.614a8.514,8.514,0,0,0-4.337,1.1l-2.193-1.1-2.145,1.1q-15.252,0-22.755-17.035l-1.074-5.314q3.508-30.824,20.565-30.824Zm-11.89,28.72q0,8.037,8.673,10.625l9.747-3.208a53.877,53.877,0,0,1,1.071-9.571q-2.922-7.039-6.529-8.522H195.76Q189.278,341.278,189.279,347.593Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "c",
    attrs: {
      "d": "M130.025,187.279q2.819,6.146,6.256,8.23l9.547-3.121,1.46-.273q13.761-2.579,23.709,7.693,2.792-.523,4.8,8.5,1.4,25.338-29.743,31.17l3.412,8.825,2.587,11.648q.285,1.278-1.109,1.541l1.963,2.3,2.588,11.648q2.2,9.9-3.057,12.7l-15.478,2.9-2.832-6.2,1.4-.262-1.965-2.3-3.456-15.55q-3.609-16.249-10.36-39.795a8.95,8.95,0,0,0,.591-4.175q-3.977-4.534-6.009-13.677a9.759,9.759,0,0,1,.242-5.444,1.278,1.278,0,0,0-1.691-1.077q-2.291-10.308,6.21-11.9Q120.285,190.438,130.025,187.279Zm6.273,21.695,4.332,12.656.582,2.618,4.187-.784q7.674-1.437,9.855-8.576l-.3-1.341q-2.005-9.027-11.839-7.185Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "c",
    attrs: {
      "d": "M218.194,191.081q24.735,6.407,24.735,21v2.507q0,6.684-3.676,17.326-3.733,0-3.733-1.282l-6.184,1.282h-16.1q-8.639.39-8.635,2.45,6.963,12.366,19.775,12.368a18.591,18.591,0,0,0,12.369-4.957h3.732v11.141q0,9.135-3.732,9.917l-4.958-1.225-8.635,1.225q-23.513-3.789-23.509-8.692-13.651-6.182-13.649-24.734.668-17.328,2.506-17.326l-1.226-2.451Q200.925,191.083,218.194,191.081ZM204.6,217.042h8.635a63.752,63.752,0,0,0,11.14-1.225,9.059,9.059,0,0,0,3.733,1.225v-1.225q0-8.469-11.141-9.917Q204.6,209.243,204.6,217.042Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "c",
    attrs: {
      "d": "M260.98,202.167l4.957,1.281,7.409-1.281q1.227,0,1.228,13.65,10.973-11.142,17.322-11.143h1.284q14.32,0,19.777,16.1,2.451,34.648,3.732,34.651,0,7.41-7.464,7.41l-2.453-1.225a9.928,9.928,0,0,1-4.959,1.225q-3.729-1.224-3.73-7.41a9.55,9.55,0,0,1,1.282-4.957q-3.344-27.243-8.692-27.243-12.371,5.294-12.367,13.593v3.734a39.727,39.727,0,0,0,1.228,9.916q-1.23,9.58-3.68,13.592l-6.239-1.225-3.678,2.45h-1.225q-4.957-2-4.957-8.634v-3.733q0-23.789-2.507-35.877h1.28a8.782,8.782,0,0,1-1.28-3.732Q258.03,202.168,260.98,202.167Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "c",
    attrs: {
      "d": "M364.6,191.081q4.791,3.678,6.186,3.677v12.369q0,6.183-2.454,6.183-1.89,0-11.139-2.452-6.406,2.34-11.143,9.917v3.677q0,9.914,7.41,9.915l12.367-1.224v1.224l2.505-1.224h1.228q2.451.39,2.45,2.452v11.14l-1.224,6.184h-8.637q-31.974,0-38.383-21V229.41h1.224a9.12,9.12,0,0,1-1.224-3.678Q323.765,200.942,364.6,191.081Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "c",
    attrs: {
      "d": "M433.793,163.839q16.1,0,16.1,4.957a9.629,9.629,0,0,0,1.223,4.9,9.068,9.068,0,0,1-1.223,3.731l1.223,12.37q-1.223,10.472-1.223,64.343a9.564,9.564,0,0,0,4.957,1.282l6.183-1.282,1.227,2.508v16.1a2.168,2.168,0,0,1-2.455,2.452h-1.222q-1.283,0-1.282-1.227a20.3,20.3,0,0,1-9.86,2.452H438.75q-7.41,0-7.407-7.41v-16.1a1.082,1.082,0,0,1,1.225-1.226l-1.225-2.451v-16.1A63.6,63.6,0,0,1,432.568,222a9.018,9.018,0,0,1-1.225-3.734h1.225a1.082,1.082,0,0,0-1.225-1.224l1.225-4.958q-1.23-30.7-2.454-34.653Q431.618,167.854,433.793,163.839Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "c",
    attrs: {
      "d": "M491.4,184.842h2.45q9.468,0,16.1,8.691v2.45q0,1.95-4.956,4.958h-3.731l-3.679-2.45q-6.684,0-8.693,4.957v3.679q5.13,8.689,13.651,8.69,14.985,11.586,16.045,21,0,29.75-21,29.749,0,1.226-7.41,1.226h-6.238a1.084,1.084,0,0,1-1.227-1.226l-2.453,1.226h-1.225q-4.958,0-4.957-17.325a1.084,1.084,0,0,0,1.226-1.227l8.636,1.227h1.281q12.369,0,12.367-11.143-2.842-11.145-18.553-18.551-7.356-7.354-8.688-14.875Q478.805,184.838,491.4,184.842Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "c",
    attrs: {
      "d": "M397.046,187.494h7.046q3.557,1.165,3.553,7.1,0,8.484-8.272,10.549-8.215-2.335-8.213-9.381V194.6Q395.3,187.493,397.046,187.494Zm14.1,21.2q1.224,21.57,3.55,40.018H413.53l1.164,2.39v5.88q0,8.7-3.55,9.436H398.21c-1.554,0-2.336-1.184-2.336-3.549q0-17.074-2.384-25.922a1.031,1.031,0,0,1,1.166-1.166L393.49,229.9V211.08a71.432,71.432,0,0,0,7.05-1.216v1.216Q402.609,209.862,411.144,208.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "c",
    attrs: {
      "d": "M163.446,444.759l-.048-10.48-40.479,8.412,40.891,10.345Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "d",
    attrs: {
      "d": "M459.018,454.6l-.055-12.164-.056-12.155,0-.751-273.468,1.25.057,12.913.063,12.94,273.465-1.258Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "e",
    attrs: {
      "d": "M482.121,442.165l-.059-12.909-14.655.065,0,.748.061,12.167.055,12.155,0,.776,14.66-.064Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "f",
    attrs: {
      "d": "M516.684,442.173l-.058-12.912-22.966.1.061,12.915.067,12.936,22.948-.107Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "c",
    attrs: {
      "d": "M485.443,141.825l.18,10.48,40.5-8.931-41.151-9.821Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "d",
    attrs: {
      "d": "M188.816,135.767l.211,12.162.21,12.155.013.75,274.313-4.746-.223-12.913-.228-12.937L188.8,134.992Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "e",
    attrs: {
      "d": "M165.8,148.495l.223,12.907,14.7-.253-.007-.748-.216-12.165-.208-12.154-.012-.777-14.706.251Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "f",
    attrs: {
      "d": "M131.127,148.929l.222,12.91,23.037-.395-.226-12.913-.232-12.935-23.02.4Z"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2118c5ee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Logo.vue
// module id = 379
// module chunks = 2